import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ChevronUp } from "feather-icons-react/build/IconComponents";
import { setToogleHeader } from "../../core/redux/action";
import { useDispatch, useSelector } from "react-redux";
import Loader from '../loader/loader';
import React, { useState, useEffect, useRef } from 'react';
import { useToast } from '../../Toaster/ToastContext';
import { apiClient } from '../../services/apiClient';
import { Table } from 'antd'

const PurchaseOrderReport = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [purchases, setPurchases] = useState([]);
  const [filteredPurchases, setFilteredPurchases] = useState([]);
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const hasFetched = useRef(false);

  const fetchPurchaseOrders = async () => {
    if (hasFetched.current) return;
    setLoading(true);
    try {
      const response = await apiClient.post('/get-all-purchase-order', {
        pageIndex: 0,
        pageSize: 50,
        previousPageIndex: 0,
      })
      if (response.status) {
        // setPurchases(response.purchases);
        // setFilteredPurchases(response.purchases); 
        const flattenedData = response.purchases.flatMap(purchase =>
          purchase.items.map((item, index) => ({
            id: `${purchase.id}-${index}`, // Unique key for each item
            invoice_no: purchase.invoice_no,
            date: purchase.date,
            product_name: item.product_name,
            purchased_amount: parseFloat(item.purchased_amount) || 0,
            purchased_quantity: item.purchased_quantity || 0,
            instock_quantity: item.instock_quantity || 0,
          }))
        );
        setPurchases(flattenedData);
        setFilteredPurchases(flattenedData);
      } else {
        setPurchases([]);
        setFilteredPurchases([]);
      }
    } catch (error) {
      showToast(error.message || 'Failed to fetch purchases', 'error', 'Purchases');
    } finally {
      setLoading(false);
      hasFetched.current = true;
    }
  };

  useEffect(() => {
    fetchPurchaseOrders();
  }, []);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setFilteredPurchases(
      purchases.filter((purchase) => {
        const invoiceNo = purchase.invoice_no || '';
        const date = purchase.date || '';
        const productMatches = purchase.items?.some((item) =>
          (item.product_name || '').toLowerCase().includes(term)
        );
        return (
          invoiceNo.toLowerCase().includes(term) ||
          date.toLowerCase().includes(term) ||
          productMatches
        );
      })
    );
  };
  
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const columns = [
    {
      title: "Invoice No",
      dataIndex: "invoice_no",
      sorter: (a, b) => (a.invoice_no || '').length - (b.invoice_no || '').length,
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      render: (text) => {
        const date = new Date(text);
        return isNaN(date) ? 'N/A' : date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }).split('/').join('-');
      },
    },
    {
      title: "Product Name",
      dataIndex: "product_name",
      sorter: (a, b) => (a.product_name || '').length - (b.product_name || '').length,
      render: (text) => text || 'N/A',
    },
    {
      title: "Purchased Amount",
      dataIndex: "purchased_amount",
      sorter: (a, b) => (a.purchased_amount || 0) - (b.purchased_amount || 0),
      render: (text) => `$${text || '0.00'}`,
    },
    {
      title: "Purchased Quantity",
      dataIndex: "purchased_quantity",
      sorter: (a, b) => (a.purchased_quantity || 0) - (b.purchased_quantity || 0),
      render: (text) => text || 0,
    },
    {
      title: "In Stock Quantity",
      dataIndex: "instock_quantity",
      sorter: (a, b) => (a.instock_quantity || 0) - (b.instock_quantity || 0),
      render: (text) => text || 0,
    },
  ];

  return (
    <div>
      <Loader loading={loading} />
      <div className="page-wrapper" style={{ position: 'relative', minHeight: '100vh' }}>
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Purchase order report</h4>
                <h6>Manage your Purchase order report</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          {/* /product list */}
          <div className="card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      onChange={handleSearch}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
              </div>
              {/* <div className="table-responsive">
                <table className="table datanew">
                  <thead>
                    <tr>
                      <th>Invoice No</th>
                      <th>Date</th>
                      <th>Product Name</th>
                      <th>Purchased Amount</th>
                      <th>Purchased Quantity</th>
                      <th>In Stock Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredPurchases.length > 0 ? (
                      filteredPurchases.map((purchase, purchaseIndex) => (
                        purchase.items?.map((item, itemIndex) => (
                          <tr key={`${purchaseIndex}-${itemIndex}`}>
                            {itemIndex === 0 && (
                              <td rowSpan={purchase.items.length}>{purchase.invoice_no}</td>
                            )}
                            {itemIndex === 0 && (
                              <td rowSpan={purchase.items.length}>
                                {purchase.date
                                  ? purchase.date.split('-').reverse().join('-')
                                : 'N/A'}
                              </td>
                            )}
                            <td>{item.product_name || 'N/A'}</td>
                            <td>${item.purchased_amount || '0.00'}</td>
                            <td>{item.purchased_quantity || 0}</td>
                            <td>{item.instock_quantity || 0}</td>
                          </tr>
                        ))
                      ))
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center">
                          No purchases found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div> */}
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={filteredPurchases}
                  rowKey={(record) => record.id}
                  rowSelection={null}
                />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrderReport;
